import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllDistrict,
  getAllDoner,
  getAllProvince,
} from "../../store/actions/donerAction";
import Spinner from "../common/Spinner";

const Dashboard = () => {
  const dispatch = useDispatch();
  const [province, setProvince] = useState("");
  const [district, setDistrict] = useState("");
  const [bloodGroup, setBloodGroup] = useState("");

  useEffect(() => {
    dispatch(getAllDoner(province, district, bloodGroup));
  }, [dispatch, province, district, bloodGroup]);

  useEffect(() => {
    dispatch(getAllProvince());
  }, [dispatch]);

  const resourceState = useSelector((state) => {
    return state.donerReducer;
  });

  const onChangeProvince = (id) => {
    setProvince(id);
    dispatch(getAllDistrict(id));
  };

  const onChangeDistrict = (id) => {
    setDistrict(id);
  };

  const onChangeBloodGroup = (value) => {
    setBloodGroup(value);
  };

  return (
    <Spinner spinning={resourceState.loading}>
      <h1 style={{ textAlign: "center", margin: 20 }}>WELCOME TO BLOOD BANK</h1>
      <h3 style={{ textAlign: "center", margin: 5 }}>
        Donate your blood or search for blood
      </h3>
      <h3 style={{ textAlign: "center", margin: 5, fontWeight: "bold" }}>
        Total Donor: {resourceState?.getDoner?.results?.length}
      </h3>
      <div style={{ padding: 20 }}>
        <Button
          type="primary"
          size="middle"
          style={{ fontWeight: "bold" }}
          onClick={() => (window.location.href = "/donate-blood")}
        >
          Donate Blood
        </Button>
      </div>
      <div style={{ padding: 20 }}>
        <h2>Filter</h2>
        <Row gutter={[15, 15]}>
          <Col xxl={4} xl={4} lg={8} md={8} sm={24} xs={24}>
            <Select
              showSearch
              showArrow
              allowClear
              style={{ width: "100%" }}
              placeholder="Select Blood Group"
              onChange={onChangeBloodGroup}
            >
              <Select.Option value="A+">A+</Select.Option>
              <Select.Option value="A-">A-</Select.Option>
              <Select.Option value="B+">B+</Select.Option>
              <Select.Option value="B-">B-</Select.Option>
              <Select.Option value="AB+">AB+</Select.Option>
              <Select.Option value="AB-">AB-</Select.Option>
              <Select.Option value="O+">O+</Select.Option>
              <Select.Option value="O-">O-</Select.Option>
            </Select>
          </Col>
          <Col xxl={4} xl={4} lg={8} md={8} sm={24} xs={24}>
            <Select
              showSearch
              showArrow
              allowClear
              optionFilterProp="children"
              placeholder="Select Province"
              onChange={onChangeProvince}
              style={{ width: "100%" }}
            >
              {resourceState.getProvince.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col xxl={4} xl={4} lg={8} md={8} sm={24} xs={24}>
            <Select
              showSearch
              showArrow
              allowClear
              optionFilterProp="children"
              placeholder="Select District"
              style={{ width: "100%" }}
              onChange={onChangeDistrict}
            >
              {resourceState.getDistrict.map((item) => (
                <Select.Option key={item.district} value={item.district}>
                  {item.district}
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
      </div>
      <div style={{ padding: "0 20px" }}>
        <Row gutter={[15, 15]}>
          {resourceState &&
            resourceState.getDoner.results &&
            resourceState.getDoner.results.map((item) => {
              return (
                <Col xxl={4} xl={6} lg={8} md={12} sm={24} xs={24}>
                  <Card
                    title={item.fullName}
                    style={{
                      width: "100%",
                      cursor: "pointer",
                      background: "lightblue",
                    }}
                  >
                    <p>Blood Group: {item.bloodGroup}</p>
                    <p>Mobile: {item.mobile}</p>
                    <p>Age: {item.age}</p>
                    <p>Province: {item.province}</p>
                    <p>District: {item.district}</p>
                    <p>City: {item.city}</p>
                    <p>Ward No: {item.ward}</p>
                    <p>Tole: {item.tole}</p>
                  </Card>
                </Col>
              );
            })}
        </Row>
      </div>
    </Spinner>
  );
};

export default Dashboard;
